const i = (r) => r / 100, g = ({
  polygonFillVisible: r = !0,
  polygonFillColor: n = "#5E63E5",
  polygonFillOpacity: d = 40,
  polygonStrokeVisible: p = !0,
  polygonStrokeColor: o = "#5E63E5",
  polygonStrokeOpacity: c = 100,
  polygonStrokeWidth: y = 2,
  lineStrokeVisible: u = !0,
  lineStrokeColor: a = "#5E63E5",
  lineStrokeOpacity: t = 100,
  lineStrokeWidth: e = 2,
  inActiveTransparent: l = !0
}) => [
  // ACTIVE
  // line stroke for LineString for Polygon Draw Mode
  {
    id: "gl-draw-line-draw-polygon-mode",
    type: "line",
    filter: [
      "all",
      ["==", "$type", "LineString"],
      ["==", "active", "true"],
      ["==", "mode", "pl_draw_polygon"]
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": a,
      "line-width": e,
      "line-opacity": i(t),
      "line-opacity-transition": {
        duration: 0,
        delay: 0
      },
      "line-width-transition": {
        duration: 0,
        delay: 0
      },
      "line-color-transition": {
        duration: 0,
        delay: 0
      }
    }
  },
  // line stroke for LineString
  {
    id: "gl-draw-line",
    type: "line",
    filter: [
      "all",
      ["==", "$type", "LineString"],
      ["==", "active", "true"],
      ["!=", "mode", "pl_draw_polygon"]
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": a,
      "line-width": e,
      "line-opacity": i(t),
      "line-opacity-transition": {
        duration: 0,
        delay: 0
      },
      "line-width-transition": {
        duration: 0,
        delay: 0
      },
      "line-color-transition": {
        duration: 0,
        delay: 0
      }
    }
  },
  // polygon fill
  {
    id: "gl-draw-polygon-fill",
    type: "fill",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "true"]],
    paint: {
      "fill-color": n,
      "fill-opacity": i(d),
      "fill-opacity-transition": {
        duration: 0,
        delay: 0
      },
      "fill-color-transition": {
        duration: 0,
        delay: 0
      }
    }
  },
  // polygon outline stroke
  {
    id: "gl-draw-polygon-stroke",
    type: "line",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "true"]],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": o,
      "line-opacity": i(c),
      "line-width": y,
      "line-opacity-transition": {
        duration: 0,
        delay: 0
      },
      "line-width-transition": {
        duration: 0,
        delay: 0
      },
      "line-color-transition": {
        duration: 0,
        delay: 0
      }
    }
  },
  // polygon mid points halo
  {
    id: "gl-draw-polygon-midpoint-halo",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
    paint: {
      "circle-radius": 6,
      "circle-color": o
    }
  },
  // polygon mid points
  {
    id: "gl-draw-polygon-midpoint",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
    paint: {
      "circle-radius": 4,
      "circle-color": "#FFF",
      "circle-opacity": 0.4
    }
  },
  // vertex point halos
  {
    id: "gl-draw-polygon-and-line-vertex-halo",
    type: "circle",
    filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
    paint: {
      "circle-radius": 6,
      "circle-color": n
    }
  },
  // vertex points
  {
    id: "gl-draw-polygon-and-line-vertex",
    type: "circle",
    filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
    paint: {
      "circle-radius": 4,
      "circle-color": "#FFF"
    }
  },
  // // INACTIVE
  // line stroke
  {
    id: "gl-draw-line-static",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"], ["==", "active", "false"]],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": a,
      "line-opacity": l ? 0 : i(t),
      "line-width": l ? 0 : e
    }
  },
  // polygon fill
  {
    id: "gl-draw-polygon-fill-static",
    type: "fill",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "false"]],
    paint: {
      "fill-color": n,
      "fill-opacity": l ? 0 : i(d)
    }
  },
  // polygon outline stroke
  {
    id: "gl-draw-polygon-stroke-static",
    type: "line",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "false"]],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": o,
      "line-opacity": l ? 0 : i(t),
      "line-width": l ? 0 : e
    }
  }
];
export {
  g as generateDrawPolygonToolStyles
};
//# sourceMappingURL=index.es379.js.map
